<template>
    <div class="goods-detail">
        <bread-crumb :list="[{
            text: '商品',
            url: '/main/goodsLibrary/nav/goodsList'
        }, {
            text: '商品详情'
        }]"/>
        <div class="goods-detail-header" v-loading="isFirstLoading">
            <div class="goods-info" :class="{ 'no-right-line': goodsInfo.status === -1 }">
                <div class="goods-img-wrap">
                    <img
                        class="goods-img"
                        :src="goodsInfo.img_url ? getQiniuImgUrl(goodsInfo.img_url) : notHasPic"
                    />
                </div>
                <div class="goods-descript">
                    <div class="goods-name">{{ goodsInfo.name }}<span v-if="goodsInfo.status === -1" class="color-red">（已删除）</span></div>
                    <div class="goods-price-unit fx-v-center">
                        <!-- <span class="goods-price">{{ goodsInfo.sale_price }} </span>
                        <span>元/</span>
                        <span class="goods-unit">{{ goodsInfo.unit && goodsInfo.unit.name }}</span> -->
                        <span v-textPopper
                            class="text-popper"
                            :style="{
                                width: 'auto',
                                maxWidth: 'calc(100% - 24px)'
                            }">{{ get(goodsInfo.pricing_methods[0], 'sale_prices[0].sale_price') }}元/{{ get(goodsInfo.pricing_methods[0], 'sale_prices[0].sale_unit.name') }}</span>
                        <el-tooltip v-if="get(goodsInfo.pricing_methods[0], 'sale_prices.length') > 1"
                            effect="dark"
                            placement="top">
                            <img class="ml-4"
                                style="width: 19px"
                                src="../goods_list/images/ladder-price.svg"
                                alt="">
                            <div class="alogn-l color-fff fs-12 lh-18 pr-20"
                                slot="content">
                                <p class="align-c mb-6">阶梯价</p>
                                <p class="mb-2">起售价 (购买量>=0)：{{ get(goodsInfo.pricing_methods[0], 'sale_prices[0].sale_price') }}元/{{ get(goodsInfo.pricing_methods[0], 'sale_prices[0].sale_unit.name') }}</p>
                                <p v-for="(item) in get(goodsInfo.pricing_methods[0], 'sale_prices').slice(1)"
                                    class="mb-2"
                                    :key="item.id">购买量>={{ item.threshold }}{{ get(item, 'sale_unit.name') }}：{{ item.sale_price }}元/{{ get(item, 'sale_unit.name') }}</p>
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="goods-code-group">
                        <div class="goods-type text-popper" v-textPopper>商品类目：{{ goodsInfo.category && goodsInfo.category.name }}</div>
                        <div class="goods-group text-popper" v-textPopper>商品分组：{{ getGroup }}</div>
                        <div class="goods-code text-popper" v-textPopper>商品编码：{{ goodsInfo.goods_code }}</div>
                    </div>
                </div>
            </div>
            <div class="goods-opera" v-if="goodsInfo.status !== -1">
                <button class="btn" @click="editGoods">编辑</button>
            </div>
        </div>
        <div class="goods-detail-record">
            <el-tabs class="tabs" value="salesRecord">
                <el-tab-pane label="销售记录" name="salesRecord"></el-tab-pane>
            </el-tabs>
            <el-table v-loading="isSecondLoading"
                :height="'calc(100vh - 300px)'"
                :data="goodsSaleRecord"
                :empty-text="isSecondLoading ? ' ' : '暂无数据'">
                <el-table-column
                    type="index"
                    min-width="50"
                    label="#"/>
                <el-table-column
                    label="时间"
                    min-width="180">
                    <template slot-scope="scope">
                        <p>{{ getCreateTime(scope.row).y_m_d }}</p>
                        <p>{{ getCreateTime(scope.row).h_m_s }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    label="订单号"
                    min-width="170">
                    <template slot-scope="scope">
                        <span class="text-popper" v-textPopper>{{ scope.row.order && scope.row.order.order_no }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="130"
                    align="right">
                    <template v-slot:header="{ row }">
                        <p class="sale-icon-wrapper">
                            实际销售单价
                            <question-icon :popperWidth="200" :content="'如果商品打折，临时改价，则用折扣平均后的实际销售价格来计算。'"/>
                        </p>
                    </template>
                    <template slot-scope="{ row }">
                        <span class="text-popper" v-textPopper>{{ row.price }}元/{{ get(row, 'sale_price.sale_unit.name') || get(goodsInfo, 'sale_prices[0].sale_unit.name') }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="数/重量"
                    min-width="160"
                    align="right">
                    <template slot-scope="{ row }">
                        <span class="text-popper" v-textPopper>{{ row.amount }}{{ get(row, 'sale_price.sale_unit.name') || get(goodsInfo, 'sale_prices[0].sale_unit.name') }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="有效销售额/元"
                    min-width="180"
                    align="right">
                    <template slot-scope="{ row }">
                        <p class="text-popper" v-textPopper v-numberAlign>{{ row.subtotal }}</p>
                        <p class="fs-12 color-danger" v-if="row.order.is_refund">(已全额退款)</p>
                    </template>
                </el-table-column>
                <el-table-column min-width="80"/>
                <el-table-column
                    label="收银员"
                    width="200">
                    <template slot-scope="scope" v-if="scope.row.creator">
                        <user-info :userInfo="scope.row.creator"/>
                    </template>
                </el-table-column>
                <p v-if="goodsSaleRecord.length > 0 && !isSecondLoading" slot="append" style="text-align: center; padding: 10px;">没有更多了</p>
            </el-table>
        </div>
        <!-- component -->
        <goods-add-and-edit ref="GoodsAddAndEdit"/>
    </div>
</template>

<script>
import { ref, onBeforeMount, createComponent, computed } from "@vue/composition-api"
import $fetch from '@/api'
import GoodsAddAndEdit from '../goods_add_and_edit/goods_add_and_edit.vue'
import BreadCrumb from '@/components/bread_crumb/bread_crumb.vue'
import QuestionIcon from '@/components/question_icon/question_icon.vue'
import { openMessage } from '@/utils/system'
import { setObjectItemToFixed } from '@/utils/index'
import { getQiniuImgUrl } from '@/assets/ts/qiniu'
import get from 'lodash/get'
const notHasPic = require('./images/not_has_pic.svg')

export default createComponent({
    setup(props, ctx) {
        const isFirstLoading = ref(false)
        const isSecondLoading = ref(false)
        const goodsInfo = ref({})
        const goodsSaleRecord = ref([])

        const getGroup = computed(() => {
            if (!goodsInfo.value.group) { return }
            let str = goodsInfo.value.group.name
            if (goodsInfo.value.secondary_group.name != null) {
                str += ' / ' + goodsInfo.value.secondary_group.name
            }
            return str
        })

        const id = ctx.root.$route.query.id
        const intId = +id

        onBeforeMount(() => {
            getGoodsInfo()
            getSaleRecode()
        })

        // 获取商品信息
        const getGoodsInfo = () => {
            if (Number.isNaN(intId)) { return }
            isFirstLoading.value = true
            return $fetch.post({
                url: '/goods/getgoods',
                params: {
                    goods_id: intId
                }
            }).then(data => {
                console.log('商品信息', data)
                goodsInfo.value = setObjectItemToFixed(data)
            }, e => openMessage("error", e.message || '获取商品信息失败'))
            .then(() => isFirstLoading.value = false)
        }

        // 获取销售记录
        const getSaleRecode = () => {
            if (Number.isNaN(intId)) { return }
            isSecondLoading.value = true
            return $fetch.post({
                url: '/goods/salegoodsdetail',
                params: {
                    goods_id: intId
                }
            }).then(data => {
                console.log('商品销售记录', data)
                goodsSaleRecord.value = setObjectItemToFixed(data)
            }, e => openMessage("error", e.message || '获取销售记录失败'))
            .then(() => isSecondLoading.value = false)
        }

        const getCreateTime = function(record) {
            if (!record.create_time) {
                return {}
            }
            const t = record.create_time.split(' ')
            return {
                y_m_d: t[0],
                h_m_s: t[1]
            }
        }

        const editGoods = () => {
            (ctx.refs.GoodsAddAndEdit).open({
                mode: 'update',
                goodsId: goodsInfo.value.id,
                callback: (status) => {
                    if (status === -1) {
                        ctx.root.$router.replace('/main/goodsLibrary/nav/goodsList')
                    } else {
                        getGoodsInfo()
                    }
                }
            })
        }

        return {
            isFirstLoading,
            isSecondLoading,
            goodsInfo,
            goodsSaleRecord,
            getGroup,
            getCreateTime,
            editGoods,
            getQiniuImgUrl,
            notHasPic,
            get
        }
    },

    components: {
        GoodsAddAndEdit,
        BreadCrumb,
        QuestionIcon
    }
})
</script>

<style lang="scss" scoped>
@mixin flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
}
.btn {
    margin-left: 20px;
    padding: 0;
    color: #009688;
    border: 1px solid #dddddd;
    background-color: #f9f9f9;
    box-sizing: border-box;
    width: 100px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    font-weight: bolder;
    border-radius: 4px;
    outline: none;
    ;
    &:active {
        transform: scale(0.9);
    }
}
.goods-detail-header {
    display: flex;
    padding: 12px 6px;
    background-color: #f9f9f9;
    border-top: 1px solid #ebebeb;
}

.goods-info {
    flex: 2;
    display: flex;
    border-right: 1px solid #dddddd;

    &.no-right-line {
        border-right: none;
    }
}
.goods-img-wrap {
    width: 67px;
    height: 67px;
    @include flex-center;
}
.goods-img {
    width: 100%;
    height: auto;
    display: block;
}
.goods-descript {
    margin-left: 12px;
    flex: 1;
    display: flex;
    flex-direction: column;
}
.goods-name {
    font-size: 16px;
    font-weight: bolder;
    color: #333;
    line-height: 22px;
}
.goods-price-unit {
    margin-top: 4px;
    font-size: 14px;
    font-weight: bolder;
    color: #333;
    line-height: 20px;
    .goods-price {
        color: #ff7c56;
    }
}
.goods-code-group {
    margin-top: 4px;
    display: flex;
    .goods-type, .goods-group, .goods-code {
        width: auto;
        margin-right: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #333;
    }
    .good-code {
        flex: 1;
    }
}
.goods-opera {
    flex: 1;
    display: flex;
    align-items: center;
}
.cashier-th {
    padding-right: 15px;
    display: flex;
    justify-content: space-between;
    .icongengduoda {
        color: #888;
    }
}
.cashier {
    display: flex;
    align-items: center;
    .cashier-avatar-wrap {
        width: 20px;
        height: 20px;
        border: 1px solid #3c90ff;
        background: #dddddd;
        border-radius: 50%;
        overflow: hidden;
        .cashier-avatar {
            width: 100%;
            height: auto;
            display: block;
        }
    }
    .cashier-name {
        flex: 1;
        margin-left: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        .cashier-name-supplement {
            color: #999;
        }
        padding-right: 15px;
    }
}
// 实际销售单价右边那个 ？图标
.sale-icon-wrapper {
    display: inline-flex;
    align-items: center;
}
</style>